const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;
const DECIMAL_PLACES_SMALL = 1;
const DECIMAL_PLACES_LARGE = 2;

/**
 * Formats a number of bytes into a human-readable string (B, KB, MB).
 */
export function formatBytes(bytes: number | null): string {
  if (bytes === null) {
    return "–";
  }
  if (bytes < BYTES_PER_KB) {
    return `${bytes} B`;
  }
  if (bytes < BYTES_PER_MB) {
    return `${(bytes / BYTES_PER_KB).toFixed(DECIMAL_PLACES_SMALL)} KB`;
  }
  return `${(bytes / BYTES_PER_MB).toFixed(DECIMAL_PLACES_LARGE)} MB`;
}

const CENTS_PER_UNIT = 100;

/**
 * Formats an integer amount of minor units (cents) as a decimal money string.
 * Pure: callers prepend their own currency symbol from the i18n layer.
 * `formatMoney(2320)` → "23.20".
 */
export function formatMoney(cents: number | null | undefined): string {
  const value = (cents ?? 0) / CENTS_PER_UNIT;
  return value.toFixed(DECIMAL_PLACES_LARGE);
}

/** Parses a decimal money string ("23.50") into integer cents (2350). */
export function parseMoneyToCents(input: string): number {
  const n = Number.parseFloat(input.replace(",", "."));
  if (Number.isNaN(n)) {
    return 0;
  }
  return Math.round(n * CENTS_PER_UNIT);
}
